<template>
  <v-dialog
    :fullscreen="isMobile"
    :hide-overlay="isMobile"
    v-model="dialog"
    width="80%"
    :content-class="dialogContentClass"
  >
    <v-card class="pa-3" :class="{ 'dialog-card--tall': isTallDialog }">
      <v-container class="pa-0 d-flex">
        <v-btn icon color="grey darken-2" @click="dialog = false" class="pa-5" x-small>
          <v-icon class="close-hover" size="28">mdi-close</v-icon>
        </v-btn>
      </v-container>
      <component
        :is="name"
        :idProp="id"
        :accountProp="accountProp"
        :notStore="notStore"
        :typeProp="typeProp"
        :currentStatus="currentStatus"
        :currentBoard="currentBoard"
        :copy="copy"
        @get="get"
        :dialogStatus="dialog"
        @close="dialog = false"
        @idNull="id = null"
        @fetchBoard="$emit('fetchBoard', $event)"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import account from "../../../pages/account/customer";
import product from "../../../pages/product/product";
import productTurnover from "../../../pages/product/turnover";
import accountingPrint from "../../../pages/accounting/print";
import accountingTurnover from "../../../pages/accounting/turnover";
import payment from "../../../pages/treasury/payments";
import check from "../../../pages/treasury/check";
import task from "../../../pages/task/task";
export default {
  name: "Index",
  components: {
    productTurnover,
    accountingTurnover,
    product,
    check,
    task,
    payment,
    account,
    accountingPrint,
  },
  props: ["dialogProp", "dataProp"],
  data: () => ({
    dialog: false,
    name: null,
    accountProp: null,
    notStore: null,
    typeProp: null,
    id: null,
    currentStatus: null,
    currentBoard: null,
    copy: null,
  }),
  computed: {
    isTallDialog() {
      return this.name === "productTurnover" || this.name === "accountingTurnover";
    },
    dialogContentClass() {
      return this.isTallDialog ? "app-dialog--tall" : "";
    },
    components: {
      get() {
        return this.$store.state.components;
      },
      set(val) {
        this.$store.commit("SET_COMPONENTS", val);
      },
    },
  },
  watch: {
    components() {},
    dialog() {
      if (!this.dialog) {
        this.$emit("close");
      }
    },
    dialogProp() {
      if (this.dialogProp) {
        this.dialog = true;
      }
    },
    dataProp() {
      if (this.dataProp) {
        this.open(this.dataProp);
      }
    },
  },
  mounted() {
    if (this.dialogProp) {
      this.dialog = true;
    }
    if (this.dataProp) {
      this.open(this.dataProp);
    }
  },
  methods: {
    get(data) {
      this.$emit("get", data);
    },
    open(item) {
      this.id = item.id;
      this.name = item.name;
      this.accountProp = item.accountProp;
      this.notStore = item.notStore;
      this.typeProp = item.type;
      this.currentStatus = item.customStatus;
      this.currentBoard = item.board;
      this.copy = item.copy;
    },
  },
};
</script>

<style>
.app-dialog--tall {
  height: 90vh !important;
  max-height: 90vh !important;
}
.app-dialog--tall .dialog-card--tall {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.app-dialog--tall .dialog-card--tall > .container {
  flex: 0 0 auto;
}
.app-dialog--tall .dialog-card--tall .app-list-page--fixed {
  flex: 1 1 auto;
  min-height: 0;
  height: 100% !important;
  max-height: none !important;
}
</style>
